import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ApprovalQueueItem = ({ item, onApprove, onReject, onViewDetails }) => {
  const getPriorityColor = () => {
    switch (item?.priority) {
      case 'Hoch': return 'text-error bg-error/10';
      case 'Mittel': return 'text-warning bg-warning/10';
      case 'Niedrig': return 'text-success bg-success/10';
      default: return 'text-muted-foreground bg-muted';
    }
  };

  const getTypeIcon = () => {
    switch (item?.type) {
      case 'Datenzugriff': return 'Lock';
      case 'Massenaktion': return 'Users';
      case 'Systemänderung': return 'Settings';
      case 'Datenlöschung': return 'Trash2';
      default: return 'FileText';
    }
  };

  return (
    <div className="bg-card rounded-lg p-4 border border-border hover:bg-muted/50 transition-colors">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-start gap-3 flex-1">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name={getTypeIcon()} size={20} color="var(--color-primary)" />
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-medium text-foreground mb-1">{item?.title}</h4>
            <p className="text-xs text-muted-foreground mb-2">{item?.description}</p>
            <div className="flex items-center gap-3 flex-wrap">
              <div className="flex items-center gap-1">
                <Icon name="User" size={12} className="text-muted-foreground" />
                <span className="text-xs text-muted-foreground">{item?.requestedBy}</span>
              </div>
              <div className="flex items-center gap-1">
                <Icon name="Clock" size={12} className="text-muted-foreground" />
                <span className="text-xs text-muted-foreground">{item?.timeAgo}</span>
              </div>
              <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${getPriorityColor()}`}>
                {item?.priority}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button 
          variant="outline" 
          size="sm" 
          iconName="Eye" 
          iconPosition="left"
          onClick={() => onViewDetails(item)}
        >
          Details
        </Button>
        <Button 
          variant="success" 
          size="sm" 
          iconName="Check" 
          iconPosition="left"
          onClick={() => onApprove(item)}
        >
          Genehmigen
        </Button>
        <Button 
          variant="destructive" 
          size="sm" 
          iconName="X" 
          iconPosition="left"
          onClick={() => onReject(item)}
        >
          Ablehnen
        </Button>
      </div>
    </div>
  );
};

export default ApprovalQueueItem;